import { WidgetTab } from '@pages/AdditionalServices/containers/widgetTabsContext';
import { servicesDirectoriesService } from '@services/requests/servicesService/servicesDirectoriesService';

import { CUSTOMS_PAYMENTS_GROUP_TEMPLATE, DELIVERY_SECTION_ID } from './consts';

const customsPaymentsRootCache = new Map<string, Promise<boolean>>();

/**
 * Является ли вкладка разделом таможенных платежей. У корня шаблона нет, смотрим на 1-й уровень.
 * TODO: убрать, когда для таможенных платежей сделают восстановление и шаринг
 */
export const isCustomsPaymentsRootDirectory = (rootDirectoryId: string): Promise<boolean> => {
  const cachedResult = customsPaymentsRootCache.get(rootDirectoryId);

  if (cachedResult) {
    return cachedResult;
  }

  const resultPromise = servicesDirectoriesService()
    .GetServicesByPath(rootDirectoryId)
    .then((directories) =>
      (directories ?? []).some((directory) => directory.template === CUSTOMS_PAYMENTS_GROUP_TEMPLATE)
    )
    .catch(() => {
      customsPaymentsRootCache.delete(rootDirectoryId);
      return false;
    });

  customsPaymentsRootCache.set(rootDirectoryId, resultPromise);

  return resultPromise;
};

/**
 * Раздел меню для вкладки: доставка или id корневой директории доп. услуг
 */
export const getTabSectionId = (tab: WidgetTab | undefined): string =>
  !tab || tab.type === 'delivery' ? DELIVERY_SECTION_ID : String(tab.data?.id ?? '');
